import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import axios from 'axios'

Vue.config.productionTip = false;

Vue.use({
    install (Vue) {
    Vue.prototype.$api = axios.create({
        // baseURL: 'http://188.21.139.1/api/v1'
      // baseURL: 'http://192.168.178.51:8001/api/v1'
      //   baseURL: 'http://localhost:8001/api/v1'
      //   baseURL: 'https://localhost:8001/api/v1'
        baseURL: 'https://gamberg.at:8734/api/v1'
    })
  }
});

new Vue({
  render: h => h(App),
}).$mount('#app');
